import { useState as o, useCallback as u, useEffect as s, useRef as v, useLayoutEffect as y } from "react";
import { BREAKPOINTS as p } from "./libServer.js";
import { EVENTS_HE as P, LOCALIZED_DOMAINS as F, MODULES_HE as K, addDaysToDate as N, calculateDaysDifference as U, debounce as Z, dispatchEvent as j, formatDateToLocale as q, getHeaders as G, getServerHeaders as J, isBrowser as Q, parseCookies as X } from "./libServer.js";
function k(e) {
  const [t, n] = o(!!e), r = u(() => n(!0), []), i = u(() => n(!1), []), f = u(() => n((w) => !w), []);
  return { value: t, setValue: n, setTrue: r, setFalse: i, toggle: f };
}
function B(e, t = 500) {
  const [n, r] = o(e);
  return s(() => {
    const i = setTimeout(() => r(e), t);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), n;
}
function A() {
  const [e, t] = o({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return s(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
const C = typeof window < "u" ? y : s;
function O(e, t) {
  const n = v(e);
  C(() => {
    n.current = e;
  }, [e]), s(() => {
    if (!t && t !== 0)
      return;
    const r = setTimeout(() => {
      n.current();
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [t]);
}
function R() {
  const { width: e } = A();
  let t = "desktop";
  return e && e <= p.MOBILE ? t = "mobile" : e && e <= p.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop"
  };
}
function W(e, t, n) {
  s(() => {
    if (window)
      return window.addEventListener(e, t, n), () => {
        window.removeEventListener(e, t, n);
      };
  }, [e, t, n]);
}
function I() {
  const e = v(!1), t = u(() => e.current, []);
  return s(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t;
}
function M(e) {
  return Array.isArray(e);
}
function V({
  promiseFn: e,
  enabled: t = !0,
  initialData: n
}) {
  const r = v(0), i = I(), [f, w] = o(n ?? void 0), [l, h] = o(t ?? !1), [S, g] = o(void 0), [D, E] = o(t ?? !1), [m, L] = o(!1), a = u(
    async (...d) => {
      const T = ++r.current;
      l || h(!0);
      try {
        if (!M(d))
          throw new Error("Invalid arguments provided to the promise function.");
        const c = await e(...d);
        i() && T === r.current && (w(c), h(!1), E(!1));
      } catch (c) {
        if (i() && T === r.current)
          throw c instanceof Error ? g(c) : g(new Error("An unknown error occurred")), h(!1), E(!1), c;
      }
    },
    [i, l, e]
  );
  s(() => {
    D && !m && a();
  }, [D, a, m]);
  const b = u(
    async (...d) => {
      L(!0), E(!0), await a(...d), L(!1);
    },
    [a]
  );
  return { data: f, loading: l, error: S, refetching: m, refetch: b };
}
export {
  p as BREAKPOINTS,
  P as EVENTS_HE,
  F as LOCALIZED_DOMAINS,
  K as MODULES_HE,
  N as addDaysToDate,
  U as calculateDaysDifference,
  Z as debounce,
  j as dispatchEvent,
  q as formatDateToLocale,
  G as getHeaders,
  J as getServerHeaders,
  Q as isBrowser,
  X as parseCookies,
  k as useBoolean,
  B as useDebounce,
  R as useDevice,
  W as useEvent,
  I as useMountedState,
  V as usePromise,
  O as useTimeout,
  A as useWindowSize
};
